import { AxiosRequestConfig } from 'axios';
import { httpConfig } from 'src/lib/modules/http';
import { Api } from 'src/api';
import { PaginatedResponse } from 'src/api/Client';
import { ApiQueryObject } from '../../api-query-params';
import { DownloadActivityResponse } from './download-activity.types';

const baseUrl = `${httpConfig.options.baseURL}/request-download-activities`;

const index = (
  params?: ApiQueryObject,
  config?: AxiosRequestConfig,
): Promise<PaginatedResponse<DownloadActivityResponse>> =>
  Api.http.get(baseUrl, { params, ...config });

export { index };
